import React from 'react';

import { AdminRoutePage } from '@constants/routes';
import { RouteConfig, RouteType } from '@modules/shared/route';
import AuthPage from './AuthPage';

export default [
  { path: AdminRoutePage.Authentication, type: RouteType.Unauthorized, component: <AuthPage /> },
] as RouteConfig[];
